<template lang="pug">
.crud
  modal-purchase-orders-prop(:id="newRecord.id")
  modal-purchase-orders-detail(:currency="newRecord.currency_id" :exchange_rate="parseFloat(newRecord.exchange_rate)" :detail='detail', :index='index', :is-add='isModalAdd')
  .container-fluid
    vm-row.heading(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        div
          h2 {{ getTitle() }}: &nbsp;{{ newRecord.folio ? newRecord.folio : '' }}
      vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
        div
          vm-button#saveRecord.vm-con-loading__container(icon="save-outline" :disabled="$v.newRecord.$invalid || newRecord.status != '1'" @click="saveRecord") {{ $t('strings.save') }}
          vm-tooltip(:text="$t('strings.options')" delay=".5s")
            vm-dropdown(vm-custom-content vm-trigger-click)
              vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

              vm-dropdown-menu
                vm-dropdown-item.d-flex.justify-content-between(@click="printRecord(newRecord)" :disabled="!enabledEdit")
                  vm-icon(icon="printer-outline")
                  slot &nbsp;{{ $t('strings.print') }}
                vm-dropdown-item.d-flex.justify-content-between(v-if="newRecord.status == '1'" @click="deletePurchaseOrderConfirm(newRecord)" :disabled="!enabledEdit")
                  vm-icon(icon="trash-2-outline")
                  slot &nbsp;{{ $t('strings.delete') }}
                vm-dropdown-item.d-flex.justify-content-between(v-if="newRecord.status == '1'" @click="setActionPurchaseOrder(newRecord, 'send')")
                  vm-icon(icon="checkmark-circle-outline")
                  slot &nbsp;{{ $t('strings.send') }}
                vm-dropdown-item.d-flex.justify-content-between(v-if="newRecord.status == '1'" @click="setActionPurchaseOrder(newRecord, 'cancelled')")
                  vm-icon(icon="close-circle-outline")
                  slot &nbsp;{{ $t('strings.cancelled') }}
                vm-dropdown-item.d-flex.justify-content-between(v-if="newRecord.status == '2'" @click="setActionPurchaseOrder(newRecord, 'received')")
                  vm-icon(icon="checkmark-circle-outline")
                  slot &nbsp;{{ $t('strings.received') }}
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-tabs
          vm-tab(:vm-label="$t('purchase_orders.general')")
            vm-row.form(vm-align="center" vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-lg=2)
                b-form-group
                  b &nbsp;&nbsp;* Es stock &nbsp;&nbsp;
                  vm-switch.tax-switch(v-model="newRecord.is_stock")
            vm-row.form(vm-align="center" vm-type="flex" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-lg=4)
                b-form-group
                  vm-select(url="quotations" column="folio" autocomplete :placeholder='$t("purchase_orders_detail.quotation_id")' v-model="newRecord.quotation_id" :default-value="newRecord.quotation ? newRecord.quotation.folio : ''" :label='$t("purchase_orders_detail.quotation_id")' @input-change="autoCompleteFunc" :disabled="newRecord.is_stock")
                    vm-select-item(:key="index" :value="item.id" :text="item.folio" v-for="(item,index) in purchaseOrdersCatalog.quotations")
              vm-col(vm-justify="center", vm-align="center", vm-lg=4)
                b-form-group
                  vm-select(url="suppliers" column="name" createObject @create-object="newObjectFuncView" autocomplete :placeholder='$t("purchase_orders.supplier_id_placeholder")' :default-value="!isAdd ? newRecord.supplier.name : ''" :danger="!$v.newRecord.supplier_id.numeric" :danger-text="'Name must have at least 4 ' + $v.newRecord.supplier_id.$params.numeric + ' letters.'" v-model="newRecord.supplier_id" :label='$t("purchase_orders.supplier_id")' @input-change="autoCompleteFunc" :disabled="newRecord.status != '1'")
                    vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in purchaseOrdersCatalog.suppliers")
              vm-col(vm-justify="center", vm-align="center", vm-lg=4)
                b-form-group
                  vm-select(:placeholder="$t('strings.multiple')" label="Status" v-model="newRecord.status" disabled)
                    vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
              vm-col(vm-justify="center", vm-align="center", vm-lg=4)
                b-form-group
                  vm-date-picker.filter(type="date" :label="$t('purchase_orders.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="newRecord.created_at" style="width=100%;" disabled)
              vm-col(vm-justify="center", vm-align="center", vm-lg=4)
                b-form-group
                  vm-select(url="addresses" column="address" autocomplete :placeholder='$t("purchase_orders.shipping_address_id_placeholder")' :danger="!$v.newRecord.shipping_address_id.numeric" :danger-text="'Name must have at least 4 ' + $v.newRecord.shipping_address_id.$params.numeric + ' letters.'" v-model="newRecord.shipping_address_id" :label='$t("purchase_orders.shipping_address_id")' @input-change="autoCompleteFunc" :disabled="newRecord.status != '1'")
                    vm-select-item(:key="index" :value="item.id" :text="item.address" v-for="(item,index) in purchaseOrdersCatalog.addresses" v-if="(newRecord.quotation && newRecord.quotation.id) == item.quotation_id || item.quotation_id == null")
              vm-col(vm-justify="center", vm-align="center", vm-lg=2)
                b-form-group
                  vm-input(:placeholder='$t("purchase_orders.delivery_time_placeholder")' :danger="!$v.newRecord.delivery_time.minLength" :danger-text="'Is required'" v-model="newRecord.delivery_time" :label='$t("purchase_orders.delivery_time")' :disabled="newRecord.status != '1'" type="Number")
              vm-col(vm-justify="center", vm-align="center", vm-lg=2)
                b-form-group
                  vm-select(:placeholder='$t("purchase_orders.delivery_unit_placeholder")' v-model="newRecord.delivery_unit" :label='$t("purchase_orders.delivery_unit")' :disabled="newRecord.status != '1'")
                    vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in deliveryUnits")
              vm-col(vm-justify="center", vm-align="center", vm-lg=4)
                b-form-group
                  vm-input(:danger="!$v.newRecord.fletes" :danger-text="'Is required'" v-model="newRecord.fletes" :label='$t("purchase_orders.fletes")' :disabled="newRecord.status != '1'" type="Number")
              vm-col(vm-justify="center", vm-align="center", vm-lg=4)
                b-form-group
                  vm-select(autocomplete :placeholder='$t("purchase_orders.currency_id_placeholder")' :danger="!$v.newRecord.currency_id.numeric" :danger-text="'Name must have at least 4 ' + $v.newRecord.currency_id.$params.numeric + ' letters.'" v-model="newRecord.currency_id" :label='$t("purchase_orders.currency_id")' :disabled="newRecord.status != '1'")
                    vm-select-item(:key="index" :value="item.id" :text="currencyText(item)" v-for="(item,index) in purchaseOrdersCatalog.currencies")
              vm-col(vm-justify="center", vm-align="center", vm-lg=4)
                b-form-group
                  vm-input(:danger="!$v.newRecord.exchange_rate" :danger-text="'Is required'" v-model="newRecord.exchange_rate" :label='$t("purchase_orders.exchange_rate")' :disabled="newRecord.status != '1'" type="Number")
              vm-col(vm-justify="center", vm-align="center", vm-lg=4)
                b-form-group
                  label {{$t("purchase_orders.comments")}}
                  vm-textarea(v-model="newRecord.comments" counter="400" :disabled="newRecord.status != '1'")
              vm-col(vm-justify="center", vm-align="center", vm-lg=4)
                b-form-group
                  vm-date-picker.filter(type="date" :label="$t('purchase_orders.payment_date_limit')" :placeholder="$t('strings.select_date')" @on-change="paymentLimitChange" :value="newRecord.payment_date_limit" style="width=100%;")
            vm-tabs
              vm-tab(vm-label="Details" vm-alignment="fixed")
                vm-table(multiple v-model="selected"  max-height="350px" :data="detailsList")
                  template(slot="header")
                    .d-flex.justify-content-between
                      div
                      div
                        vm-tooltip(:text="$t('strings.addDetail')" delay=".5s")
                          vm-button(size="small" icon="plus" @click="addPurchaseOrderDetail" :disabled="newRecord.status != '1'")
                  template(slot="thead")
                    vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('purchase_orders_detail.' + column) }}
                    vm-th
                  template(slot-scope="{data}")
                    vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                      vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                        slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                        slot(v-if="column != 'status' && column != 'total' && column != 'unit_price' && column != 'product_id' && column != 'number_part'") {{data[indextr][column]}}
                        slot(v-if="column == 'status'") {{data[indextr]['status_display']}}
                        slot(v-if="column == 'product_id'") {{data[indextr]['product'].sku}} <br> {{data[indextr]['product'].name}}
                        slot(v-if="column == 'number_part'") {{data[indextr]['product'].number_part}}
                      vm-td
                      vm-dropdown(vm-custom-content vm-trigger-click :disabled="newRecord.status != '1'")
                        vm-button(type="flat" icon="more-horizotnal" color="#afbbc6" :disabled="newRecord.status != '1'")

                        vm-dropdown-menu
                          vm-dropdown-item.d-flex.justify-content-between(@click="editPurchaseOrderDetail(data[indextr], indextr)")
                            vm-icon(icon="edit-2-outline")
                            slot &nbsp;{{ $t('strings.edit') }}
                          vm-dropdown-item.d-flex.justify-content-between(@click="deletePurchaseOrderDetailConfirm(data[indextr], indextr)")
                            vm-icon(icon="trash-2-outline")
                            slot &nbsp;{{ $t('strings.delete') }}
                vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" vm-w="12")
                  vm-col(vm-w=6)
                    vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" style="text-align: right;")
                      vm-col
                        b Flete:&nbsp;&nbsp;
                        span(style="font-size: 1.4rem;") {{ newRecord.fletes | currency }}
                    vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" style="text-align: right;")
                      vm-col
                        b Subtotal:&nbsp;&nbsp;
                        span(style="font-size: 1.4rem;") {{ subtotal | currency }}
                    vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" style="text-align: right;")
                      vm-col
                        vm-switch.tax-switch(v-model="newRecord.is_tax")
                        b &nbsp;&nbsp;Iva 16%:&nbsp;&nbsp;
                        span(style="font-size: 1.4rem;") {{ iva | currency }}
                    vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" style="text-align: right;")
                      vm-col
                        b Total:&nbsp;&nbsp;
                        span(style="font-size: 1.4rem;") {{ total | currency }}
          vm-tab(:vm-label="$t('purchase_orders.tracking')")
            TrackingTab
  transition(name="enter")
    .footer(v-if="enabledSave && !$v.newRecord.$invalid")
      vm-button(type="flat" text-color="#fff" color="rgb(190, 142, 241)" @click="cancel") {{ $t('strings.cancel') }}
      vm-button(type="default" @click="saveRecord") {{ $t('strings.save') }}
</template>

<script>
import ModalPurchaseOrdersProp from '@/components/modals/ModalPurchaseOrdersProp.vue'
import ModalPurchaseOrdersDetail from '@/components/modals/ModalPurchaseOrdersDetail.vue'
import TrackingTab from '@/components/purchase-order/TrackingTab.vue'
import { required, numeric, minLength } from 'vuelidate/lib/validators' // Ver documentacion
import parseDeleteMany from '@/utils/parseDeleteMany'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')

export default {
  name: 'PurchaseOrdersDetail',
  components: {
    ModalPurchaseOrdersDetail,
    ModalPurchaseOrdersProp,
    TrackingTab
  },
  props: {
    isAdd: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    newRecord: {
      status: 1,
      is_tax: true,
      is_stock: true,
      created_at: new Date(),
      currency_id: 2,
      exchange_rate: 1,
      tax: 0,
      fletes: 0,
      comments: ' ',
      details: [],
      delivery_unit: 'days'
    },
    isModalAdd: true,
    detail: {},
    index: 0,
    selected: [],
    enabledSave: false,
    columns: ['quantity', 'product_id', 'number_part', 'unit_price', 'total'],
    status: [
      {
        text: 'Pendiente',
        value: 1,
        color: 'primary'
      },
      {
        text: 'Enviada',
        value: 2,
        color: 'warning'
      },
      {
        text: 'Cancelado',
        value: 3,
        color: 'danger'
      },
      {
        text: 'Recibida',
        value: 4,
        color: 'success'
      },
      {
        text: 'Recibido parcialmente',
        value: 5,
        color: '#FFD000'
      }
    ],
    deliveryUnits: [
      {
        text: 'Dias',
        value: 'days'
      },
      {
        text: 'Semanas',
        value: 'weeks'
      }
    ]
  }),
  validations: {
    newRecord: {
      supplier_id: {
        required,
        numeric
      },
      currency_id: {
        required,
        numeric
      },
      shipping_address_id: {
        required,
        numeric
      },
      delivery_time: {
        required,
        minLength: minLength(1)
      },
      fletes: {},
      exchange_rate: {
        required
      }
    }
  },
  computed: {
    ...mapGetters(['purchaseOrder', 'purchaseOrdersCatalog']),
    detailsList () {
      let t = this
      return this.newRecord.details.map(detail => {
        parseFloat(detail.unit_price_raw) === 0.0 &&
          (detail.unit_price_raw = detail.unit_price)
        if (
          detail.edit !== undefined &&
          parseInt(detail.product.currency_id) !==
            parseInt(t.newRecord.currency_id)
        ) {
          parseInt(detail.product.currency_id) === 1
            ? (detail.unit_price = parseFloat(
              parseFloat(detail.unit_price_raw) *
                  parseFloat(t.newRecord.exchange_rate)
            ).toFixed(2))
            : (detail.unit_price = parseFloat(
              parseFloat(detail.unit_price_raw) / t.newRecord.exchange_rate
            ).toFixed(2))
        } else if (
          parseInt(detail.product.currency_id) !==
          parseInt(t.newRecord.currency_id)
        ) {
          parseInt(detail.product.currency_id) === 1
            ? (detail.unit_price = parseFloat(detail.product.mxn_price).toFixed())
            : (detail.unit_price = parseFloat(
              parseFloat(detail.unit_price_raw) / t.newRecord.exchange_rate
            ).toFixed(2))
        } else {
          detail.unit_price = parseFloat(detail.unit_price_raw)
        }
        detail.subtotal = (
          parseFloat(detail.unit_price) * parseFloat(detail.quantity)
        ).toFixed(2)
        detail.total = parseFloat(detail.subtotal)
        return detail
      })
    },
    detailsLength () {
      return this.newRecord.details.length
    },
    enabledEdit () {
      return this.newRecord.id
    },
    iva () {
      let iva = 0
      this.newRecord.is_tax && (iva = parseFloat(this.subtotal) * 0.16)
      return iva
    },
    subtotal () {
      return (
        parseFloat(this.newRecord.fletes) +
        parseFloat(
          this.newRecord.details
            .reduce((prev, cur) => prev + parseFloat(cur.total), 0)
            .toFixed(2)
        )
      )
    },
    total () {
      // let iva = parseFloat(this.subtotal) * 0.16
      return parseFloat(this.subtotal) + parseFloat(this.iva)
    }
  },
  watch: {
    newRecord (record) {
      Object.keys(record).length > 2
        ? (this.enabledSave = true)
        : (this.enabledSave = false)
    },
    purchaseOrder (purchaseOrder) {
      this.newRecord = { ...purchaseOrder }
      this.getCatalogAux()
    },
    'purchaseOrder.details' (details) {
      this.newRecord.details = []
      details.map(e => this.newRecord.details.push({ ...e }))
    },
    iva (iva) {
      this.newRecord.tax = iva
    },
    'newRecord.currency_id' (id) {
      this.newRecord.exchange_rate = this.purchaseOrdersCatalog.currencies.find(
        currency => currency.id === id
      ).exchange_rate
    }
  },
  async created () {
    this.initPurchaseOrder(this.newRecord)
    this.getCatalog()
    this.$route.params.id && (await this.getPurchaseOrder())
  },
  methods: {
    ...mapActions([
      'initPurchaseOrder',
      'addPurchaseOrder',
      'editPurchaseOrder',
      'deletePurchaseOrders',
      'deletePurchaseOrderDetail',
      'deletePurchaseOrderDetails',
      'actionPurchaseOrder',
      'loadPurchaseOrder',
      'loadCatalog',
      'loadCatalogAux',
      'setModalVisible',
      'setModalPropVisible'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === code)['color']
    },
    getTitle () {
      return this.isAdd
        ? this.$t('purchase_orders.add')
        : this.$t('purchase_orders.edit')
    },
    addPurchaseOrderDetail () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.detail = {}
    },
    editPurchaseOrderDetail (detail, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.detail = { ...detail }
      this.index = index
    },
    async saveRecord () {
      if (!this.enabledSave) return
      this.enabledSave = false
      this.newRecord.tax = this.iva
      let t = this
      this.$vm.loading({
        background: 'primary',
        color: '#fff',
        container: '#saveRecord',
        scale: 0.45
      })
      this.newRecord.subtotal = this.subtotal
      this.newRecord.total = this.total;
      (await this.isAdd)
        ? this.addPurchaseOrder(this.newRecord).then(() => {
          t.$router.push({ name: 'purchaseOrders' })
        })
        : this.editPurchaseOrder(this.newRecord).then(() => {
          t.$router.push({ name: 'purchaseOrders' })
        })
    },
    async deletePurchaseOrderConfirm (purchaseOrder) {
      let t = this
      this.auxDeletePurchaseOrder = () => {
        t.deletePurchaseOrder(purchaseOrder).then(() => {
          t.$router.push({ name: 'purchaseOrders' })
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', {
          model: this.$t('strings.purchase_order'),
          attribute: this.$t(purchaseOrder.folio)
        }),
        accept: this.auxDeletePurchaseOrder
      })
    },
    async deletePurchaseOrderDetailConfirm (detail, index) {
      let t = this
      this.auxDeletePurchaseOrderDetail = () => {
        t.deletePurchaseOrderDetail({ detail, index }).then(() => {
          t.selected = []
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', {
          model: this.$t('strings.purchase_order'),
          attribute: detail.id ? detail.id : index
        }),
        accept: this.auxDeletePurchaseOrderDetail
      })
    },
    async deletePurchaseOrderDetailsConfirm () {
      let t = this
      let purchaseOrdersMany = parseDeleteMany(this.selected, 'id')
      this.auxDeletePurchaseOrderDetail = () => {
        t.deletePurchaseOrderDetails(purchaseOrdersMany).then(() => {
          t.selected = []
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', {
          model: this.$t('strings.purchase_order'),
          attribute: purchaseOrdersMany.indexes
        }),
        accept: this.auxDeletePurchaseOrderDetail
      })
    },
    async setActionPurchaseOrder (record, action) {
      let t = this
      this.auxActionPurchaseOrder = () => {
        t.actionPurchaseOrder({ id: record.id, action })
      }
      this.$vm.dialog({
        color: 'warning',
        title: this.$t('strings.purchase_order'),
        text: this.$t('front.action_confirmation', {
          model: this.$t('strings.purchase_order'),
          action: this.$t('purchase_orders.' + action)
        }),
        accept: this.auxActionPurchaseOrder
      })
    },
    async getPurchaseOrder (page) {
      this.loadPurchaseOrder(this.$route.params)
    },
    async getCatalog () {
      Object.keys(this.purchaseOrdersCatalog).forEach(e =>
        this.loadCatalog({ url: e, filter: '' })
      )
    },
    getCatalogAux () {
      Object.keys(this.purchaseOrdersCatalog).forEach(e => {
        let arr = []
        Object.keys(this.newRecord).forEach(d => {
          if (e === d) {
            arr.push({ ...this.newRecord[d] })
            this.loadCatalogAux({ url: e, data: arr })
          }
        })
        arr = []
        this.newRecord.details.map(d => {
          let dd = { ...d }
          Object.keys(dd).forEach(f => {
            let concat = `${f}s`
            if (e === concat) {
              arr.push({ ...dd[f] })
              this.loadCatalogAux({ url: e, data: arr })
            }
          })
        })
      })
    },
    printRecord (record) {
      this.setModalPropVisible(true)
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute(
        'column'
      )
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute(
        'url'
      )
      payload.filter = `?${column}=*${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    },
    paymentLimitChange (date) {
      this.newRecord.payment_date_limit = date
    },
    cancel () {
      this.$router.push({ name: 'purchaseOrders' })
    },
    currencyText (item) {
      return `${item.name} ${item.code}`
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.form {
  padding: 20px 10px 0;
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.con-vm-tabs {
  padding: 10px;
  .vm-tabs--ul {
    box-shadow: none;
  }
  .vm-tabs--content {
    padding: 0;
  }
}
.vm-col {
  padding: 0 10px;
}
.vm-table--header {
  padding: 0px !important;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
          display: block;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
.tax-switch {
  display: inline-block;
  input {
    position: relative !important;
  }
}
</style>
